import { AllessehContentQueryBody } from 'hooks/useAllessehContentQuery';
import * as BARRONS_ADVISOR from './barrons-advisor';
import * as INVESTOR_CIRCLE from './investor-circle';
import * as MAGAZINE from './magazine';
import * as VIDEO from './video';
import { DEFAULT_QUERY } from '../default';

export type QueryOptionBarrons = {
  query: AllessehContentQueryBody;
  label: string;
  type: BARRONS_ADVISOR.SECTION_ENUM | INVESTOR_CIRCLE.SECTION_ENUM | MAGAZINE.SECTION_ENUM | VIDEO.SECTION_ENUM | null;
  url: string | null;
};

type QueryOptions = {
  [key: string]: QueryOptionBarrons[];
};

type QueryConfig = {
  [key: string]: QueryOptions;
};

export const QUERY_CONFIG_BARRONS: QueryConfig = {
  homepage: {
    BARRONS_ADVISOR: [
      {
        query: BARRONS_ADVISOR.BARRONS_ADVISOR,
        label: 'Barrons Advisor',
        type: BARRONS_ADVISOR.SECTION_ENUM.BARRONS_ADVISOR,
        url: null
      }
    ],
    INVESTOR_CIRCLE: [
      {
        query: INVESTOR_CIRCLE.INVESTOR_CIRCLE,
        label: 'Investor Circle',
        type: INVESTOR_CIRCLE.SECTION_ENUM.INVESTOR_CIRCLE,
        url: null
      }
    ],
    MAGAZINE: [
      {
        query: MAGAZINE.MAGAZINE,
        label: 'Magazine',
        type: MAGAZINE.SECTION_ENUM.MAGAZINE,
        url: null
      }
    ],
    MAGAZINE_COVER: [
      {
        query: MAGAZINE.MAGAZINE_COVER,
        label: 'Magazine Cover',
        type: MAGAZINE.SECTION_ENUM.MAGAZINE_COVER,
        url: null
      }
    ],
    VIDEO_LIST: [
      {
        query: VIDEO.VIDEO,
        label: 'Video',
        type: VIDEO.SECTION_ENUM.VIDEO,
        url: null
      }
    ]
  },
  default: {
    default: [
      {
        query: {
          ...DEFAULT_QUERY,
          query: {
            and: [{ term: { key: 'Product', value: 'barrons.com' } }]
          }
        },
        label: 'Custom Query',
        type: null,
        url: null
      }
    ]
  }
};
